import React, {useEffect, useState } from 'react';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useParams } from "react-router";
import Swal from 'sweetalert2';
import { getEventGalleryById, editEventGallery } from '../../Service';
import { useSelector} from 'react-redux';
import ImageUploading from 'react-images-uploading';

export default function EditGalleryreview(){
const [date, setDate] = useState(new Date());
const [images, setImages] = React.useState([]);
const maxNumber = 69;
const [formErrors, setFormErrors] = useState({});
let loggedUser = useSelector(store => store.user['user']);
let user_id = '';
if(loggedUser){
  user_id = loggedUser.id;
}

 
 let params = useParams();
 const eventgalid = params.epro_id;

 const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
    const field1='image';
    setFormValues(prevState => ({
    ...prevState,
    [field1]:  imageList[0]['file']
}));
  };

 console.log('params', params.epro_id);

 
const initialValues = { title: params.title, 
                        date: params.date, 
                        author: params.author, 
                        gallery_name:params.gallery_name, 
                        address: params.address, 
                        city: params.city, 
                        country: params.country, 
                        website: params.website, 
                        image_caption: params.image_caption, 
                        description: params.description, 
                        review: params.review, 
                        address_2: params.address_2, 
                        image: ""};
 const [formValues, setFormValues] = useState(initialValues);

 useEffect(() => {

    let params={review_id:eventgalid};
    getEventGalleryById(params).then(res => handleProgramResponse(res))
},[]);

const handleProgramResponse = (response) => {
    //console.log('log 60', response.data.data)
    setFormValues(response.data.data)
}

const handleChange = (e) => {
    //console.log('log 42', e.target.value);
    const value=e.target.value;
    const field=e.target.name;
    setFormValues(prevState => ({
        ...prevState,
        [field]:  value  }));
  }

  const handleBackSubmit = (e) =>
  {
    window.location = "../galleryreviews";
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const errorCount = validate(formValues);
    setFormErrors(errorCount);
    if(errorCount.status){
        formValues['status']=1;
    editEventGallery(formValues).then(res => handleResponse(res))
    }else{
        window.scrollTo(100, 100);
  return false;
    }
  }

  const handleResponse = (response) => {
    if(response.data.code==400){ 
      const errors = {};
      Swal.fire({
        icon: 'warning',
        title: response.data.message,
        text: response.data.data.ProgammingDate,
      })
      errors.status = false;
      setFormErrors(errors);
    }
    else if(response.data.code==200){ 
      const errors = {};
      Swal.fire({
        icon: 'success',
        title: response.data.message,
        text: 'Event gallery review Updated successfully',
      }).then(function() {
        window.location = "../galleryreviews";
    });
      errors.status = false;
      setFormErrors(errors);
    }
  }

  const validate = (values) => {
    // console.log('log 63', values);
    // return false;
    const errors = {};
    errors.status = true;
    // if(!values.fair){
    //     errors.fair = 'Fair is required';
    //     errors.status = false;
    // } 
    if(!values.title){
        errors.title = 'Title is required';
        errors.status = false;
    } 
    if(!values.date){
        errors.date = 'Date is required';
        errors.status = false;
    } 

    if(!values.author){
        errors.author = 'Author time is required';
        errors.status = false;
    } 

    if(!values.gallery_name){
      errors.gallery_name = 'Gallery name is required';
      errors.status = false;
  
    } 

    if(!values.address){
      errors.address = 'Address name is required';
      errors.status = false;
  
    } 


    if(!values.address_2){
      errors.address_2 = 'Address 2 name is required';
      errors.status = false;
  
    } 

    if(!values.city){
      errors.city = 'City name is required';
      errors.status = false;
  
    } 

    if(!values.country){
      errors.country = 'Country name is required';
      errors.status = false;
  
    } 

    if(!values.image_caption){
      errors.image_caption = 'Image caption name is required';
      errors.status = false;
  
    } 

    
    if(!values.description){
      errors.description = 'Description caption name is required';
      errors.status = false;
  
    } 

    if(!values.review){
      errors.review = 'Review caption name is required';
      errors.status = false;
  
    }

    
  
    return errors;
}

console.log('log 193', formValues.date)
return(
<section className="admin-section">
<div className="container">
<div className="row">
<div className="col-md-12 col-12">
<div className="admin-edit">
<h1>Edit Gallery Reviews</h1>
<Form>
<Form.Group>
<Form.Label>Title <span className='star'>*</span></Form.Label>
<Form.Control type="Name" name="title"   onChange={handleChange} value={formValues.title} placeholder="Title" />
<p className="error">{formErrors.title}</p>
</Form.Group>

<Form.Group controlId="date">
<Form.Label>Date <span className='star'>*</span></Form.Label>
<Form.Control
type="date"
name="date"
placeholder="Date"
defaultValue={formValues.date}
onChange={(e) => handleChange(e )}
/>
<p className="error">{formErrors.date}</p>
</Form.Group>

<Form.Group>
<Form.Label>Author <span className='star'>*</span></Form.Label>
<Form.Control type="Name" name="author"   onChange={handleChange} value={formValues.author} placeholder="Author" />
<p className="error">{formErrors.author}</p>
</Form.Group>

<Form.Group>
<Form.Label>Gallery Name <span className='star'>*</span></Form.Label>
<Form.Control type="Name" name="gallery_name"   onChange={handleChange} value={formValues.gallery_name} placeholder="Gallery Name" />
<p className="error">{formErrors.gallery_name}</p>
</Form.Group>

<Form.Group>
<Form.Label>Address<span className='star'>*</span></Form.Label>
<Form.Control as="textarea" rows="2" name="address" type="Name"    onChange={handleChange} value={formValues.address} placeholder="Address" />
<p className="error">{formErrors.address}</p>
</Form.Group>

<Form.Group>
<Form.Label>Address 2<span className='star'>*</span></Form.Label>
<Form.Control as="textarea" rows="2" name="address_2"   onChange={handleChange} value={formValues.address_2} type="Name" placeholder="Address2" />
<p className="error">{formErrors.address_2}</p>
</Form.Group>

<Row>
<Col md={6}>
<Form.Group>
<Form.Label>City <span className='star'>*</span> </Form.Label>
<Form.Control type="Name"  name="city"   onChange={handleChange} value={formValues.city} placeholder="City" />
<p className="error">{formErrors.city}</p>
</Form.Group>
</Col>
<Col md={6}>
<Form.Group>
<Form.Label>Country <span className='star'>*</span> </Form.Label>
<Form.Control type="Name" name="country"   onChange={handleChange} value={formValues.country} placeholder="Country" />
<p className="error">{formErrors.country}</p>
</Form.Group>
</Col>
</Row>

<Form.Group>
<Form.Label>Website</Form.Label>
<Form.Control type="Name" name="website"   onChange={handleChange} value={formValues.website} placeholder="Website" />
</Form.Group>

<Form.Group>
<Form.Label>Image Caption <span className='star'>*</span></Form.Label>
<Form.Control type="Name" name="image_caption"   onChange={handleChange} value={formValues.image_caption} placeholder="Image Caption " />
<p className="error">{formErrors.image_caption}</p>
</Form.Group>

<Form.Group>
<Form.Label>Description <span className='star'>*</span></Form.Label>
<Form.Control as="textarea" rows="3" name="description"   onChange={handleChange} value={formValues.description}  type="Name" placeholder="Description" />
<p className="error">{formErrors.description}</p>
</Form.Group>

<Form.Group>
<Form.Label>Reviews <span className='star'>*</span></Form.Label>
<Form.Control  type="Name" name="review"   onChange={handleChange} value={formValues.review} placeholder="Reviews" />
<p className="error">{formErrors.review}</p>
</Form.Group>
<Form.Group>
<Form.Label>Cover Image</Form.Label>
<ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={maxNumber}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          // write your building UI
          <div className="choose-file">
            <button type='button'
              style={isDragging ? { color: 'red' } : undefined}
              onClick={onImageUpload}
              {...dragProps}
              >
              <img src={process.env.PUBLIC_URL+'/images/crop-image.png'}/>
            </button>
            <br/><br/>
            {formValues.image_path ? <img src={formValues.image_path.replace('http://localhost/storage/','https://dev.datanetiix.com/photola_api/storage/app/public/')}/> : ''}
            <br/>
            <br/>
            &nbsp;
            {/* <button type='button' onClick={onImageRemoveAll}>Remove all images</button> */}
            {imageList.map((image, index) => (
              <div key={index} className="image-item">
                <img src={image['data_url']} alt="" width="100" />
                
              </div>
            ))}
          </div>
        )}
      </ImageUploading>
</Form.Group>
<Button variant="primary" type="submit" onClick={handleSubmit} className='common-btn btn btn-secondary'>
Save
</Button>
<Button variant="primary" type="button" onClick={()=> handleBackSubmit()} className='cancel-btn btn btn-primary'>
Cancel
</Button>
</Form>
</div>
</div>
</div>
</div>
</section>
)
}